import apiClient from './apiClient';

/**
 * Fetch Andy's notes from the backend
 * @returns {Promise} Promise that resolves to notes data
 */
export const fetchAndyNotes = async () => {
    try {
        const response = await apiClient.get('/api/notes/andy_notes');
        return response.data;
    } catch (error) {
        console.error('Error fetching Andy notes:', error);
        throw error;
    }
}; 